import React from 'react';
import { Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { states } from '@/constants/lifecycle';
import { fetchRequestWorkspace } from '../actions';
import { requestWorkspaceIcon } from '../helper';
import { requestWorkspaceStates } from '../constants';
import RequestWorspaceIconMessage from './RequestWorspaceIconMessage';

const RequestWorkspaceStatusButton = ({ className, fetchData, request }) => (
  <Button
    size="tiny"
    labelPosition="left"
    disabled={request.workspaceReadStatus === states.PENDING}
    loading={request.workspaceReadStatus === states.PENDING}
    icon
    onClick={() => fetchData(request.code)}
    basic
    className={clsx(
      'aridhia-request-workspace-status-button',
      className,
      requestWorkspaceIcon(request, requestWorkspaceStates.REFRESH).color,
    )}
  >
    <RequestWorspaceIconMessage request={request} defaultStatus={requestWorkspaceStates.REFRESH} />
  </Button>
);

const mapDispatchToProps = {
  fetchData: fetchRequestWorkspace,
};

export default connect(null, mapDispatchToProps)(RequestWorkspaceStatusButton);
